var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
                            name: 'Map',
                            path: '/map',
                            icon: 'ni ni-pin-3 text-orange'
                          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Trips',
            path: '/trips',
            icon: 'ni ni-compass-04 text-yellow'
            }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'GPS Devices',
          path: '/gps-devices',
          icon: 'ni ni-world-2 text-red'
        }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Checkpoints',
                      path: '/checkpoints',
                      icon: 'ni ni-active-40 text-blue'
                    }}}),_c('sidebar-item',{attrs:{"link":{
                              name: 'Maintenance',
                              path: '/maintenance',
                              icon: 'ni ni-settings text-green'
                            }}})],1),_c('template',{slot:"links-after"},[_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("BETA")]),_c('ul',{staticClass:"navbar-nav"},[_c('sidebar-item',{attrs:{"link":{
              name: 'Motorbikes',
              path: '/motorbikes',
              icon: 'ni ni-key-25 text-orange'
            }}})],1),_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("ALPHA")]),_c('ul',{staticClass:"navbar-nav"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Home',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary',
          }}})],1)])],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }